import * as types from './actions.js'

const initialState = {
  members: [],
  isRemoving: false,
  isOwner: false,
  showCheckmark: false,
  selectedMember: {},
  selectedDates: {},
  invited: [],
  error: null,
  isFetching: false,
  file_type: 'csv'
}

function membersReducer(state=initialState, action) {
  switch (action.type) {
    case "LOGOUT_SUCCESS":
      return initialState

    case types.ENTERPRISE_MEMBER_FAILURE:
      return {
        ...state,
        selectedMember: {},
        isFetching: false
      }
    case types.ENTERPRISE_MEMBER_REQUEST:
      return {
        ...state,
        // selectedMember: action.selectedMember,
        isFetching: true
      }
    case types.ENTERPRISE_MEMBER_SUCCESS:
      return {
        ...state,
        selectedMember: action.selectedMember,
        isFetching: false
      }
    case 'SELECT_DATES':
      return {
        ...state,
        selectedDates: action.selectedDates || state.selectedDates
      }
    case 'SELECTED_FILE_TYPE':
      return {
        ...state,
        file_type: action.file_type || state.file_type
      }

    case 'CREATE_MEMBER_INVITES_SUCCESS':
      return {
        ...state,
        invited: [...state.invited, ...action.json.data.sent_invites ? action.json.data.sent_invites.filter(m=>!m.accepted && !m.archived) : [] ],
        members: [...state.members, ...action.json.data.members ? action.json.data.members: [] ],
         //TODO flatten json.invited
        showCheckmark: true
      }

    case 'RESET_CREATE_MEMBER_INVITES_FORM': //NOTE should this instead be SHOW_CHECKMARK ?
      return {
        ...state,
        showCheckmark: false
      }

    case 'GET_ENTERPRISE_GROUP_SUCCESS':
      return {
        ...state,
        invited: [ ...action.json.sent_invites.filter(m=> !m.accepted && !m.archived) ],
        members: [ ...action.json.members||[] ],
        isOwner: true
      }
    case 'MOCK_ENTERPRISE':
      return {
        ...state,
        invited: [ 'test@test.com', 'test2@test.com' ],
        members: [ 'test@test.com', 'test2@test.com' ],
      }

    case 'GET_ENTERPRISE_GROUP_FAILURE':
      return {
        ...state,
        error: action.err
      }
    case 'REMOVE_MEMBER_REQUEST':
      return {
        ...state,
        isRemoving: true
      }

    case 'REMOVE_MEMBER_SUCCESS':
      return {
        ...state,
        isRemoving: false,
        members: state.members.filter(member => member.token_id !== action.tokenId),
      }

    case 'REMOVE_MEMBER_FAIL':
      return {
        ...state,
        isRemoving: false
      }

    default:
      return state
  }
}
export default membersReducer

// SELECTORS
export const required = value => value ? undefined : 'Required'

export const minLength = min => value =>
  value && value.trim().length < min ? `Must be ${min} characters or more` : undefined

export const minLength1 = minLength(5)

export const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined

export const isEmail = value => value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)

// export const email = value =>
//   value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value) ?
//   'Invalid email address' : undefined

export const splitBatchEmails = value => value.trim().replace(/[\n ,]+/igm,",").split(",")

export const batchEmails = (value) =>
  splitBatchEmails(value)
  .every(email=> isEmail(email))
  ? undefined : "Must be a list of emails"



// WEBPACK FOOTER //
// ./src/enterprise/members/reducer.js